import React from "react";
import { Link } from "react-router-dom";

// Maps data.json service names to their URL slugs
const SERVICE_SLUG_MAP = {
  "General Electrical Services": "general-electrical-auckland",
  "Solar & Energy Efficiency Add-ons": "solar-pv-auckland",
  "Smart Home & Office Automation": "smart-home-automation-auckland",
  "Critical Power Infrastructure": "critical-power-infrastructure-auckland",
  "Safety & Compliance": "electrical-safety-compliance-auckland",
  "24/7 Emergency Services Options": "emergency-electrician-auckland"
};

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            Explore some of the regular services we offer our residential, commercial, and industrial clients.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => {
                const slug = SERVICE_SLUG_MAP[d.name];
                const card = (
                  <div className="service-item">
                    <i className={d.icon}></i>
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                    </div>
                  </div>
                );
                return (
                  <div key={`${d.name}-${i}`} className="col-md-4 col-sm-6 col-xs-12" style={{ marginBottom: "30px" }}>
                    {slug ? (
                      <Link
                        to={`/services/${slug}`}
                        className="service-card-link"
                        aria-label={`View ${d.name} service page`}
                      >
                        {card}
                      </Link>
                    ) : card}
                  </div>
                );
              })
            : "loading"}
        </div>
      </div>
    </div>
  );
};
